
class video {
	constructor(id) {
		this.win = window;
		this.video = document.getElementById(id);
		this.src = this.video.src;
		this.is_play = false;
		this.is_scrollplay = false;
	}
	play() {
		if(!this.is_play) {
			this.video.play();
			this.is_play = true;
			console.log('MOVIE PLAY');
		}
	}
	stop() {
		if(this.is_play) {
			this.video.pause();
			this.is_play = false;
			console.log('MOVIE STOP');
		}
	}
	init() {
		const __ = this;
		return new Promise( (resolve, reject) => {
			this.video.src = this.src;
			[
				'loadstart',
				'load',
				'error',
				'emptied',
				'stalled',
			 	'loadedmetadata',
			 	'loadeddata',
			 	'canplay',
			 	'canplaythrough'
			].forEach(function(eventName) {
				__.video.addEventListener(eventName, function(v) {
					// console.log(eventName);
					resolve();
				}, true);
			});
			this.video.load();
		});
	}
}

export default video;


// WEBPACK FOOTER //
// ./src/assets/js/video.js